import styles from './EmployerPortalJobs.module.css';
import { actionsUI } from './ActionsUI';
import { jobTitleUI } from './JobTitleUI';
import { jobStatusUI } from './JobStatusUI';
import { candidateUI } from './CandidateUI';
import { datePostedUI } from './DatePostedUI';
import { useState } from 'react';

export const JobListUI = ({
    item,
    index,
    handleJobSelect,
    handleDropdownClose,
    handleJobSelectForDetail,
    isDropdownEnabled,
    handleToggleDropdown,
    selectedJobs,
    jobs
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const handleCardClick = () => {
        handleDropdownClose()
        handleJobSelectForDetail(item.id)
    }
    return (
        <div
            key={index.toString()}
            className={`${styles.row} ${styles.tableRowContainer}`}
            style={{ border: !isHovered ? '1px solid #BABBBA' : "2px solid #0364b2", backgroundColor: "white" }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div className={`${styles.tableRow} ${styles.halfContainer}`} style={{ flex: 0.2 }}>
                <input
                    type="checkbox"
                    className={styles.customCheckbox}
                    checked={selectedJobs.includes(item.id)}
                    onChange={() => handleJobSelect(item.id)}
                />
            </div>
            <div onClick={handleCardClick} className={`${styles.tableRow} ${styles.contentWrapper}`} style={{ textAlign: 'left' }}>{jobTitleUI(item)}</div>
            <div onClick={handleCardClick} className={`${styles.tableRow} ${styles.contentWrapper}`} style={{ textAlign: 'left' }}>{candidateUI(item, jobs)}</div>
            <div onClick={handleCardClick} className={`${styles.tableRow} ${styles.contentWrapper}`} style={{ textAlign: 'left' }}>{datePostedUI(item)}</div>
            <div onClick={handleCardClick} className={`${styles.tableRow} ${styles.contentWrapper}`} style={{ textAlign: 'left' }}>{jobStatusUI(item)}</div>
            <div className={`${styles.tableRow} ${styles.actionsContainer}`}>
                {actionsUI(index, item.id, selectedJobs, handleJobSelect, handleDropdownClose, isDropdownEnabled, handleToggleDropdown, handleJobSelectForDetail)}
            </div>
        </div>
    )
}

